import { render, staticRenderFns } from "./provisionServicesDialog.vue?vue&type=template&id=463c8b6e&scoped=true"
import script from "./provisionServicesDialog.vue?vue&type=script&lang=ts"
export * from "./provisionServicesDialog.vue?vue&type=script&lang=ts"
import style0 from "./provisionServicesDialog.vue?vue&type=style&index=0&id=463c8b6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463c8b6e",
  null
  
)

export default component.exports